import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchProducts } from "../api";
import { useSEO } from "../hooks/useSEO";
import { ProductCard } from "../components/ProductCard";
import { Reveal } from "../components/Reveal";
import { CAMPAIGN_FILM_URL, IMG, MANIFESTO } from "../config/brand";

export default function EditorialPage({ collection }) {
  const [products, setProducts] = useState([]);
  const title = collection ? "FALL/WINTER COLLECTION 26" : "EDITORIAL / 26";

  useSEO(`${title} — RICH KIDS FUNERAL`, "RICH KIDS FUNERAL. First Collection 26. Campaign, editorial and film.");

  useEffect(() => {
    fetchProducts().then((p) => setProducts(p.slice(0, 8))).catch(() => {});
  }, []);

  return (
    <div data-testid={collection ? "collection-editorial-page" : "editorial-page"}>
      <div className="px-3 md:px-6 pt-10 md:pt-16">
        <Reveal>
          <h1
            className={`font-medium leading-[0.95] tracking-tight ${
              collection ? "text-[#e50000] text-[11vw] md:text-[7vw]" : "text-[10vw] md:text-[5vw]"
            }`}
            data-testid="editorial-title"
          >
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="max-w-2xl text-sm md:text-base leading-relaxed text-black/70 mt-8" data-testid="editorial-description">
            {MANIFESTO}
          </p>
        </Reveal>
      </div>

      <div className="px-3 md:px-6 pt-14 md:pt-20 space-y-3 md:space-y-6">
        <Reveal>
          <div className="overflow-hidden rounded-[18px] md:rounded-[25px]">
            <video
              src={CAMPAIGN_FILM_URL}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="w-full aspect-video object-cover block"
              data-testid="editorial-video"
            />
          </div>
        </Reveal>
        <Reveal>
          <div className="overflow-hidden aspect-[3/2] bg-[#f5f4f2]">
            <img
              src={IMG.editorial}
              alt="RKF editorial featuring blue and white graphic T-shirts"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
          <Reveal>
            <Link to="/products/different-personalities-tee" className="block group">
              <div className="overflow-hidden aspect-square bg-[#f5f4f2]">
                <img
                  src={IMG.modelDP}
                  alt="RKF Different Personalities Tee campaign portrait"
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
            </Link>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/products/angel-f-tee" className="block group">
              <div className="overflow-hidden aspect-square bg-[#f5f4f2]">
                <img
                  src={IMG.modelAngel}
                  alt="RKF Angel F Tee campaign portrait"
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
            </Link>
          </Reveal>
        </div>
      </div>

      <div className="px-3 md:px-6 pt-16 md:pt-24">
        <Reveal>
          <h2 className="text-base md:text-lg font-medium tracking-[0.15em]">SHOP THE COLLECTION</h2>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 md:gap-x-6 gap-y-10 mt-8" data-testid="editorial-products">
          {products.map((p, i) => (
            <Reveal key={p.id} delay={Math.min(i * 0.04, 0.3)}>
              <ProductCard product={p} />
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-12 text-center">
          <Link
            to="/all-products"
            className="inline-block text-[11px] font-medium tracking-[0.2em] border border-black px-10 py-4 hover:bg-black hover:text-white transition-colors"
          >
            VIEW ALL PRODUCTS
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
